import { render, staticRenderFns } from "./12_VideoGallery.vue?vue&type=template&id=2817ee59&scoped=true&"
import script from "./12_VideoGallery.vue?vue&type=script&lang=js&"
export * from "./12_VideoGallery.vue?vue&type=script&lang=js&"
import style0 from "./12_VideoGallery.vue?vue&type=style&index=0&id=2817ee59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817ee59",
  null
  
)

export default component.exports